/* eslint-disable @typescript-eslint/naming-convention */
import { CreateInventoryMeterOutputDto, UpdateInventoryMeterOutputDto } from '@enmon/commons/lib/tools';
import { VFC } from 'react';
import { Descriptions } from 'antd';
import { FormattedMessage } from 'react-intl';
import { InventoryMeterOutputMessages as messages } from './messages';

export type InventoryMeterOutputDescriptionsProps = {
  order: number;
  output: CreateInventoryMeterOutputDto | UpdateInventoryMeterOutputDto;
};

export const InventoryMeterOutputDescriptions: VFC<InventoryMeterOutputDescriptionsProps> = ({ order, output }) => {
  const { technology, is_occupied, remote_reading_owner } = output;

  return (
    <Descriptions
      bordered
      column={1}
      contentStyle={{ width: '50%' }}
      labelStyle={{ width: '50%' }}
      size="small"
      title={<FormattedMessage {...messages.output} values={{ order }} />}
    >
      <Descriptions.Item label={<FormattedMessage {...messages.technology} />}>{technology}</Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.isOccupied} />}>
        <FormattedMessage
          {...messages[is_occupied ? ('yes' satisfies keyof typeof messages) : ('no' satisfies keyof typeof messages)]}
        />
      </Descriptions.Item>
      {is_occupied && (
        <Descriptions.Item label={<FormattedMessage {...messages.remoteReadingOwner} />}>
          {remote_reading_owner}
        </Descriptions.Item>
      )}
    </Descriptions>
  );
};
